import React, { FunctionComponent } from "react"
import { Helmet } from "react-helmet"

interface iProps {
  title: string
}

const Seo: FunctionComponent<iProps> = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}

export default Seo
